
  import '/vercel/path0/docs/guide/demos/cols.tsx?watch=parent';
  export default "import React from 'react';\n\nexport default () => <>Demo 分栏演示</>;\n";;
  